import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PrivateRoute from '~/components/privateRoute/privateRoute';
import PublicRoute from '~/components/publicRoute/publicRoute';
import LoginPage from '~/pages/login/login';
import ForgotPasswordPage from '~/pages/forgotPassword/forgotPassword';
import LogoutPage from '~/pages/logout/logout';
import HomePage from '~/pages/home/home';
import AgendaPage from '~/pages/agenda/agenda';
import BrewTransferReportsPage from '~/pages/brewTransferReports/brewTransferReports';
import CompletedBrewTransferReportsPage from '~/pages/completedBrewTransferReports/completedBrewTransferReports';
import BrewerySettingsPage from '~/pages/brewery/brewery';
import CustomerPage from '~/pages/customer/customer';
import CustomersPage from '~/pages/customers/customers';
import CustomerCreatePage from '~/pages/customerCreate/customerCreate';
import CustomerEditPage from '~/pages/customerEdit/customerEdit';
import CustomerOrderPage from '~/pages/customerOrder/customerOrder';
import SettingsPage from '~/pages/settings/settings';
import VesselTypesPage from '~/pages/vesselTypes/vesselTypes';
import VesselTypePage from '~/pages/vesselType/vesselType';
import VesselTypeCreatePage from '~/pages/vesselTypeCreate/vesselTypeCreate';
import VesselTypeEditPage from '~/pages/vesselTypeEdit/vesselTypeEdit';
import HSCodesPage from '~/pages/hsCodes/hsCodes';
import HSCodePage from '~/pages/hsCode/hsCode';
import HSCodeCreatePage from '~/pages/hsCodeCreate/hsCodeCreate';
import HSCodeEditPage from '~/pages/hsCodeEdit/hsCodeEdit';
import IngredientsPage from '~/pages/ingredients/ingredients';
import IngredientCreatePage from '~/pages/ingredientCreate/ingredientCreate';
import IngredientEditPage from '~/pages/ingredientEdit/ingredientEdit';
import IngredientPage from '~/pages/ingredient/ingredient';
import LocationsPage from '~/pages/locations/locations';
import LocationCreatePage from '~/pages/locationCreate/locationCreate';
import LocationEditPage from '~/pages/locationEdit/locationEdit';
import LocationPage from '~/pages/location/location';
import LotPage from '~/pages/lot/lot';
import LotEditPage from '~/pages/lotEdit/lotEdit';
import LotsPage from '~/pages/lots/lots';
import OrdersPage from '~/pages/orders/orders';
import ProductsPage from '~/pages/products/products';
import ProductPage from '~/pages/product/product';
import ProductEditPage from '~/pages/productEdit/productEdit';
import ProductCreatePage from '~/pages/productCreate/productCreate';
import ReportsPage from '~/pages/reports/reports';
import TanksPage from '~/pages/tanks/tanks';
import TankPage from '~/pages/tank/tank';
import TankCreatePage from '~/pages/tankCreate/tankCreate';
import TankEditPage from '~/pages/tankEdit/tankEdit';
import TransferSchedulePage from '~/pages/transferSchedule/transferSchedule';
import TransferSchedulesPage from '~/pages/transferSchedules/transferSchedules';
import TransferScheduleCreatePage from '~/pages/transferScheduleCreate/transferScheduleCreate';
import TransferScheduleEditPage from '~/pages/transferScheduleEdit/transferScheduleEdit';
import UpcomingBrewReportsPage from '~/pages/upcomingBrewReports/upcomingBrewReports';
import VesselsPage from '~/pages/vessels/vessels';
import SelectBreweryPage from '~/pages/selectBrewery/selectBrewery';
import NotFoundPage from '~/pages/notFound/notFound';

export default class Routes extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <PrivateRoute path="/" exact component={HomePage} />
          <PrivateRoute path="/agenda" component={AgendaPage} />
          <PrivateRoute path="/customers" exact component={CustomersPage} />
          <PrivateRoute path="/customers/create" exact component={CustomerCreatePage} />
          <PrivateRoute path="/customers/:customerId" exact component={CustomerPage} />
          <PrivateRoute path="/customers/:customerId/edit" exact component={CustomerEditPage} />
          <PrivateRoute path="/customers/:customerId/order" exact component={CustomerOrderPage} />
          <PrivateRoute path="/lots" exact component={LotsPage} />
          <PrivateRoute path="/lots/:lotId" exact component={LotPage} />
          <PrivateRoute path="/lots/:lotId/edit" exact component={LotEditPage} />
          <PrivateRoute path="/orders" exact component={OrdersPage} />
          <PrivateRoute path="/products" exact component={ProductsPage} />
          <PrivateRoute path="/products/create" exact component={ProductCreatePage} />
          <PrivateRoute path="/products/:productId" exact component={ProductPage} />
          <PrivateRoute path="/products/:productId/edit" exact component={ProductEditPage} />
          <PrivateRoute path="/reports" exact component={ReportsPage} />
          <PrivateRoute path="/reports/brewtransfer" exact component={BrewTransferReportsPage} />
          <PrivateRoute path="/reports/completedbrewtransfer" exact component={CompletedBrewTransferReportsPage} />
          <PrivateRoute path="/reports/upcomingbrews" exact component={UpcomingBrewReportsPage} />
          <PrivateRoute path="/settings" exact component={SettingsPage} />
          <PrivateRoute path="/settings/brewery" exact component={BrewerySettingsPage} />
          <PrivateRoute path="/settings/vesseltypes" exact component={VesselTypesPage} />
          <PrivateRoute path="/settings/vesseltypes/create" exact component={VesselTypeCreatePage} />
          <PrivateRoute path="/settings/vesselTypes/:vesselTypeId" exact component={VesselTypePage} />
          <PrivateRoute path="/settings/vesselTypes/:vesselTypeId/edit" exact component={VesselTypeEditPage} />
          <PrivateRoute path="/settings/hscodes" exact component={HSCodesPage} />
          <PrivateRoute path="/settings/hscodes/create" exact component={HSCodeCreatePage} />
          <PrivateRoute path="/settings/hscodes/:hsCodeId" exact component={HSCodePage} />
          <PrivateRoute path="/settings/hscodes/:hsCodeId/edit" exact component={HSCodeEditPage} />
          <PrivateRoute path="/ingredients" exact component={IngredientsPage} />
          <PrivateRoute path="/ingredients/create" exact component={IngredientCreatePage} />
          <PrivateRoute path="/ingredients/:ingredientId" exact component={IngredientPage} />
          <PrivateRoute path="/ingredients/:ingredientId/edit" exact component={IngredientEditPage} />
          <PrivateRoute path="/settings/locations" exact component={LocationsPage} />
          <PrivateRoute path="/settings/locations/create" exact component={LocationCreatePage} />
          <PrivateRoute path="/settings/locations/:locationId" exact component={LocationPage} />
          <PrivateRoute path="/settings/locations/:locationId/edit" exact component={LocationEditPage} />
          <PrivateRoute path="/settings/transfers" exact component={TransferSchedulesPage} />
          <PrivateRoute path="/settings/transfers/create" exact component={TransferScheduleCreatePage} />
          <PrivateRoute path="/settings/transfers/:transferScheduleId" exact component={TransferSchedulePage} />
          <PrivateRoute
            path="/settings/transfers/:transferScheduleId/edit"
            exact
            component={TransferScheduleEditPage}
          />
          <PrivateRoute path="/tanks" exact component={TanksPage} />
          <PrivateRoute path="/tanks/create" exact component={TankCreatePage} />
          <PrivateRoute path="/tanks/:tankId" exact component={TankPage} />
          <PrivateRoute path="/tanks/:tankId/edit" exact component={TankEditPage} />
          <PrivateRoute path="/vessels" exact component={VesselsPage} />
          <PrivateRoute path="/selectbrewery" exact component={SelectBreweryPage} />
          <PublicRoute path="/forgotpassword" exact component={ForgotPasswordPage} />
          <PublicRoute path="/login" exact component={LoginPage} />
          <Route path="/logout" component={LogoutPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/routes/routes.jsx